import { Box } from '@mui/material'

import { useTranslations } from '@/hooks/useTranslations'
import { BlockContentConsumer } from './ContentStack/BlockContentConsumer'

import type React from 'react'
import type { ReactNode } from 'react'
import type { RichText as RichTextProps } from '@/gen/sanity/schema'

export const RichText: React.FC<RichTextProps & { linkIcon?: ReactNode }> = ({ Text, linkIcon }) => {
  const { language } = useTranslations()

  return <Box>{!!Text && <BlockContentConsumer value={Text[language]} linkIcon={linkIcon} />}</Box>
}
